export const get = (obj, path, fallback) => path.split('.').reduce((a, b) => (a && a[b] ? a[b] : null), obj) ||
    fallback;
const theme = (keys, fallback) => (props) => get(props.theme, keys, fallback);
export default theme;
//# sourceMappingURL=theme.js.map